import {createContext, useContext} from "react";

export const CurrentLocaleContext = createContext({
  currentLocale: '',
  setCurrentLocale: (_: string) => {},
});

export const useCurrentLocale = () => useContext(CurrentLocaleContext);
